import React, { PropsWithChildren } from 'react';
import { IntlProvider } from 'react-intl';

export type PricingIntlProviderProps = {
  locale: string;
  messages: Record<string, string>;
};

const PricingIntlProvider = ({
  locale,
  messages,
  children
}: PropsWithChildren<PricingIntlProviderProps>) => (
  <IntlProvider locale={locale} messages={messages}>
    {children}
  </IntlProvider>
);

export { PricingIntlProvider };
